import SearchBar from "../searchBar/searchbar.component";
import logo from "../../assets/logo.png"
import "./navigation.styles.scss"
import { Outlet } from "react-router-dom";

const Navigation = () => {
    return (
        <>
            <div className="navigation">
                <div className="navigation__banner">
                    <p className="navigation__banner--text">
                        Explore amazing events and adventures&mdash; click
                        <span className="navigation__banner--link">
                            <a href="#">here</a>
                        </span>
                        to access our calendar of events and resources!
                    </p>
                </div>
                <div className="navigation__content">
                    <a href="/" className="navigation__logo-box">
                        <img src={logo} alt="logo" className="navigation__logo"/>
                    </a>
                    <div className="navigation__links">
                        <ul>
                            <li><a href="/">Home</a></li>
                            <li className="navigation__links--nested"><a href="/events">Hiking</a>
                                <ul>
                                    <li><a href="/events">Events</a></li>
                                    <li><a href="/events/programme">Programmes</a></li>
                                    <li>Destinations</li>
                                </ul>
                            </li>
                           
                            <li>Mountaineering</li>
                            <li>About Us</li>
                            <li>Shop With Us</li>
                            <li>Contact Us</li>
                        </ul>
                </div>
                <SearchBar />
                </div>
            </div>
            <Outlet />
        </>
    )
}

export default Navigation;